export type FontSizeType = 'small' | 'medium' | 'large' | 'extra-large';
export type FontFamilyType = 'montserrat' | 'system' | 'sans-serif' | 'serif' | 'monospace';

interface FontSizeConfig {
  base: string;
  small: string;
  large: string;
  heading: string;
  subheading: string;
}

interface FontFamilyConfig {
  family: string;
  name: string;
}

export const fontSizes: Record<FontSizeType, FontSizeConfig> = {
  small: {
    base: '14px',
    small: '12px',
    large: '16px',
    heading: '20px',
    subheading: '18px'
  },
  medium: {
    base: '16px',
    small: '14px',
    large: '18px',
    heading: '24px',
    subheading: '20px'
  },
  large: {
    base: '18px',
    small: '16px',
    large: '20px',
    heading: '28px',
    subheading: '24px'
  },
  'extra-large': {
    base: '20px',
    small: '18px',
    large: '22px',
    heading: '32px',
    subheading: '28px'
  }
};

export const fontFamilies: Record<FontFamilyType, FontFamilyConfig> = {
  montserrat: {
    family: '"Montserrat", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
    name: 'Montserrat (Default)'
  },
  system: {
    family: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", sans-serif',
    name: 'System Default'
  },
  'sans-serif': {
    family: 'Arial, Helvetica, sans-serif',
    name: 'Sans Serif'
  },
  serif: {
    family: 'Georgia, "Times New Roman", serif',
    name: 'Serif'
  },
  monospace: {
    family: '"Courier New", Consolas, monospace',
    name: 'Monospace'
  }
};